import { api } from "../../api";
import { ROOT_API_URL } from "../../../config/defaultSettings";

const V2_API_URL = ROOT_API_URL.replace(/\/api\/v1$/, "/api/v2");

const invoicesV2Api = api.injectEndpoints({
  tagTypes: ["InvoicesV2"],
  endpoints: (builder) => ({
    getInvoicesV2: builder.query({
      query: (params = {}) => ({
        url: `${V2_API_URL}/invoices`,
        method: "GET",
        params,
      }),
      providesTags: (result) => [
        { type: "InvoicesV2", id: "LIST" },
        ...((result?.invoices || []).map((invoice) => ({
          type: "InvoicesV2",
          id: invoice._id,
        })) || []),
      ],
    }),
    createInvoiceV2: builder.mutation({
      query(body) {
        return {
          url: `${V2_API_URL}/invoices`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "InvoicesV2", id: "LIST" }],
    }),
    getInvoiceV2: builder.query({
      query: ({ id }) => ({
        url: `${V2_API_URL}/invoices/${id}`,
        method: "GET",
      }),
      transformResponse: (response) => response.data,
      providesTags: (_result, _error, { id }) => [
        { type: "InvoicesV2", id },
      ],
    }),
    updateInvoiceV2: builder.mutation({
      query: ({ id, body }) => ({
        url: `${V2_API_URL}/invoices/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "InvoicesV2", id },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    addInvoiceV2Payment: builder.mutation({
      query: ({ id, body }) => ({
        url: `${V2_API_URL}/invoices/${id}/payments`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "InvoicesV2", id },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    sendInvoiceV2: builder.mutation({
      query: ({ id, body }) => ({
        url: `${V2_API_URL}/invoices/${id}/send`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "InvoicesV2", id },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    remindInvoiceV2: builder.mutation({
      query: ({ id, body }) => ({
        url: `${V2_API_URL}/invoices/${id}/remind`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "InvoicesV2", id },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateInvoiceV2Mutation,
  useAddInvoiceV2PaymentMutation,
  useGetInvoiceV2Query,
  useGetInvoicesV2Query,
  useRemindInvoiceV2Mutation,
  useSendInvoiceV2Mutation,
  useUpdateInvoiceV2Mutation,
} = invoicesV2Api;
